/**
 * Top bar for the chat modal with New Chat and Close buttons.
 * Positioned at the top-right, anchored to the screen top.
 */

import { Ionicons } from '@expo/vector-icons';
import { Alert, StyleSheet, Text, TouchableOpacity, View } from 'react-native';

interface ChatTopBarProps {
  topInset: number;
  onNewChat: () => void;
  onClose: () => void;
}

const BUTTON_SIZE = 38;

export function ChatTopBar({ topInset, onNewChat, onClose }: ChatTopBarProps) {
  const handleNewChatPress = () => {
    Alert.alert(
      'New Chat',
      'Start a new conversation? Current messages will be cleared.',
      [
        { text: 'Cancel', style: 'cancel' },
        { text: 'New Chat', style: 'destructive', onPress: onNewChat },
      ],
    );
  };

  return (
    <View style={[styles.container, { top: topInset + 8 }]}>
      <TouchableOpacity
        onPress={handleNewChatPress}
        style={styles.newChatButton}
        accessibilityLabel="Start a new chat"
      >
        <Text style={styles.newChatText}>New chat</Text>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={onClose}
        style={styles.closeButton}
        accessibilityLabel="Close chat"
      >
        <Ionicons name="close" size={22} color="#FFFFFF" />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    right: 16,
    zIndex: 10,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  newChatButton: {
    height: BUTTON_SIZE,
    paddingHorizontal: 14,
    borderRadius: BUTTON_SIZE / 2,
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  newChatText: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
  },
  closeButton: {
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    borderRadius: BUTTON_SIZE / 2,
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
